<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4ZM20 17.17L18.83 16H4V4H20V17.17ZM13 5H11V9H7V11H11V15H13V11H17V9H13V5Z"
      fill="url(#paint0_linear_5364_5625)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_5625"
        x1="2"
        y1="2"
        x2="22.068"
        y2="21.9315"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
